import { useState, useCallback, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import ShoppingDeals from '../Components/ShoppingDeals';
import { loginUser, isTokenExpired } from '../utils/authUtils';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
// import ClipLoader from 'react-spinners/ClipLoader';

const Base_Url = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';
const Brands = process.env.REACT_APP_API_BRANDS || 'brands';
const Membershipsignup = process.env.REACT_APP_LINK_SIGNUP || '';

const Home = () => {
    const [brands, setBrands] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // AES-GCM helpers
    const getAesKey = async () => {
        const raw = new TextEncoder().encode(process.env.REACT_APP_ENCRYPTION_AES_KEY);
        return crypto.subtle.importKey('raw', raw, 'AES-GCM', false, ['encrypt', 'decrypt']);
    };

    const b64urlToAb = (str) => {
        let b64 = str.replace(/-/g, '+').replace(/_/g, '/');
        while (b64.length % 4) b64 += '=';
        const bin = atob(b64);
        const bytes = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
        return bytes.buffer;
    };

    const decryptAesFromB64url = async (b64url) => {
        const packed = new Uint8Array(b64urlToAb(b64url));
        const iv = packed.slice(0, 12);
        const ct = packed.slice(12);
        const key = await getAesKey();
        const plainBuf = await crypto.subtle.decrypt({ name: 'AES-GCM', iv }, key, ct);
        return new TextDecoder().decode(plainBuf);
    };

    useLayoutEffect(() => {
        (async () => {
            try {
                const params = new URLSearchParams(window.location.search);
                const encKey = params.get('key');
                if (!encKey) return;

                const json = await decryptAesFromB64url(encKey);
                const data = JSON.parse(json); // { uid, tk, ts }

                // console.log('data', data.uid)
                // console.log('data1', data.tk)

                // Store in localStorage
                if (data?.uid) localStorage.setItem('userid', JSON.stringify(data.uid));
                if (data?.tk) localStorage.setItem('authToken', data.tk);

                // Call profile API
                const res = await axios.get(`${Base_Url}/membership/users/profile`, {
                    headers: { Authorization: `Bearer ${data.tk}` },
                });

                if (res.data.status === 'success') {
                    console.log('Profile:', res.data.data);
                    localStorage.setItem('userProfile', JSON.stringify(res.data.data));
                }

                // Clean URL (remove ?key=)
                const url = new URL(window.location.href);
                url.searchParams.delete('key');
                window.history.replaceState({}, document.title, url.toString());
            } catch (err) {
                console.error('Failed to decrypt or fetch profile:', err);
            }
        })();
    }, []);



    const fetchTopBrands = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            // call the top brands endpoint directly (do NOT await login)
            const response = await axios.get(`${Base_Url}/${Brands}/top`);
            if (response?.data?.status === 'success') {
                const resultBrands = (response.data.result?.brands || []).filter(b => Number(b.productCount) > 0);
                setBrands(resultBrands);
                try {
                    // cache for faster next loads
                    localStorage.setItem('top_brands', JSON.stringify(resultBrands));
                } catch (e) {
                    // ignore storage errors
                }
            } else {
                // API returned non-success, show fallback
                setError('Failed to load brands');
            }
        } catch (err) {
            console.error('fetchTopBrands error:', err?.message || err);
            setError('Failed to load brands. Please try again.');
        } finally {
            setLoading(false);
        }
    }, []);


    const init = useCallback(async () => {
        try {
            const isPageReload = performance?.navigation?.type === 1;
            const cached = localStorage.getItem("top_brands");

            if (cached && !isPageReload) {
                // show cached brands instantly
                setBrands(JSON.parse(cached));
                // in background, refresh from network
                fetchTopBrands().then((/*optional result*/) => {
                    // no blocking behavior — UI already shows cached
                });

                // start background login after starting refresh (non-blocking)
                (async () => {
                    try {
                        const token = localStorage.getItem("jwt_token");
                        const tokenExpired = token ? isTokenExpired(token) : true;
                        if (!token || tokenExpired) {
                            await loginUser(); // background refresh login
                            console.log("Background loginUser completed (cached flow).");
                        } else {
                            console.log(
                                "Token present and valid; skip background login (cached flow)."
                            );
                        }
                    } catch (e) {
                        console.warn(
                            "Background login failed (cached flow):",
                            e?.message || e
                        );
                        // await registerUser();
                        // token = localStorage.getItem('jwt_token');
                    }
                })();
                return;
            }

            // No cache or reload: fetch top brands first (await it so UI shows actual result)
            await fetchTopBrands();

            // After brand fetch completed, trigger background login (do not await)
            (async () => {
                try {
                    const token = localStorage.getItem("jwt_token");
                    const tokenExpired = token ? isTokenExpired(token) : true;
                    if (!token || tokenExpired) {
                        await loginUser(); // background login; non-blocking for UI
                        console.log("Background loginUser completed (fresh flow).");
                    } else {
                        console.log(
                            "Token present and valid; skipping background login (fresh flow)."
                        );
                    }
                } catch (e) {
                    console.warn(
                        "Background login failed (fresh flow):",
                        e?.message || e
                    );
                    // await registerUser();
                    // token = localStorage.getItem('jwt_token');
                }
            })();
        } catch (err) {
            console.error("init error:", err);
            setError("Initialization failed.");
        }
    }, [fetchTopBrands]);


    // Load as early as possible
    // In Home.js

    useLayoutEffect(() => {
        const cachedBrands = localStorage.getItem("top_brands");

        if (cachedBrands) {
            // Show cached brands instantly
            setBrands(JSON.parse(cachedBrands));
            setLoading(false);

            // Background refresh
            let token = localStorage.getItem('jwt_token');
            fetchTopBrands(token).then((res) => {
                if (res?.brands) {
                    localStorage.setItem("top_brands", JSON.stringify(res.brands));
                    setBrands(res.brands); // refresh UI
                }
            });
        } else {
            // First time: show skeletons until API returns
            init();
        }
    }, [fetchTopBrands, init]);



    // const handlePageChange = (page) => {
    //     if (page >= 1 && page <= totalPages) {
    //         setCurrentPage(page);
    //         const brandsSection = document.getElementById('brands');
    //         if (brandsSection) {
    //             brandsSection.scrollIntoView({ behavior: 'smooth' });
    //         }
    //     }
    // };


    const handleRetry = () => {
        setError(null);
        // setCurrentPage(1);
    };

    // const renderPaginationItems = () => {
    //     const range = [];
    //     const delta = 2;
    //     const start = Math.max(2, currentPage - delta);
    //     const end = Math.min(totalPages - 1, currentPage + delta);

    //     range.push(1);

    //     if (start > 2) {
    //         range.push('...');
    //     }

    //     for (let i = start; i <= end; i++) {
    //         range.push(i);
    //     }

    //     if (end < totalPages - 1) {
    //         range.push('...');
    //     }

    //     if (totalPages > 1) {
    //         range.push(totalPages);
    //     }

    //     return range.map((page, i) =>
    //         page === '...' ? (
    //             <li key={`ellipsis-${i}`}>
    //                 <span className="page-numbers">...</span>
    //             </li>
    //         ) : (
    //             <li key={page}>
    //                 <button
    //                     onClick={() => handlePageChange(page)}
    //                     className={`page-numbers ${currentPage === page ? 'current' : ''}`}
    //                     aria-label={`Go to page ${page}`}
    //                 >
    //                     {page}
    //                 </button>
    //             </li>
    //         )
    //     );
    // };

    if (error) {
        return (
            <div className="accent-custom">
                <Header />
                <main>
                    <div className="container py-5">
                        <div className="alert alert-danger text-center">
                            <h4>Error</h4>
                            <p>{error}</p>
                            <button
                                className="btn btn-primary"
                                onClick={handleRetry}
                            >
                                Retry
                            </button>
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
        );
    }

    return (
        <div className="accent-custom">
            <Header />
            <main>
                <section className="tp-slider-area p-relative z-index-1">
                    <div className="tp-slider-active tp-slider-variation swiper-container">
                        <div className="swiper-wrapper">
                            <div className="tp-slider-item is-light d-flex swiper-slide">
                                <div className="container slider_container p-0">
                                    <div className="row g-0">
                                        <div className="col-xl-12 col-lg-12 col-md-12">
                                            <div className="homebanner_slider_wrapper">
                                                <div id="carouselhomebanner" className="carousel slide" data-bs-ride="carousel">
                                                    <div className="carousel-inner">
                                                        <div className="carousel-item active">
                                                            <div className="slide1_wrapper p-relative">
                                                                <div className="slide1_overlay" />
                                                                <div className="p-relative z-index-0">
                                                                    <div className="container">
                                                                        <div className="row justify-content-end">
                                                                            <div className="col-xl-6 col-lg-12 col-md-12 col-12">
                                                                                <div className="slide1_description">
                                                                                    <h1 className="slide1_title pt-10">Shop with<br /> Insider Access</h1>
                                                                                    <div className="pt-35 slide1_txt">All the Brands You Know<br /> &amp; Love in One Place</div>
                                                                                    <div className="d-inline-flex justify-content-end pt-45 pb-15"><div className="slide1_save">Save even more as a <span className="f_blue2 f_mextrabold">CircleOne</span>&nbsp;Member</div></div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="container p-0">
                                                                        <div className="row">
                                                                            <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                                                                                <div className="slide1_bottomtxt">From the Team Behind My Military Savings &amp; My Military Lifestyle</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="carousel-item">
                                                            <div className="slide2_wrapper">
                                                                <div className="container">
                                                                    <div className="row align-items-center">
                                                                        <div className="col-xl-7 col-lg-7 col-md-12 col-12 p-relative">
                                                                            <div className="slide2_description z-index-0 p-relative">
                                                                                <h1 className="slide2_title">Get up to 12% Cash Back</h1>
                                                                                <div className="pt-15 slide2_subtitle">With a <span className="f_mextrabold">CircleOne</span> Membership</div>
                                                                                <div className="slide2_para pt-25">On eligible purchases, plus counseling and other benefits for you and your family. CircleOne was built for the military community - by the military community.</div>
                                                                                <div className="pt-25 pb-25"><a href={`${Membershipsignup}/signup`} className="tp-btn-blue1 tp_lrgebtn_pdng2 f_sz16 f_msemibold crsr_pntr">Sign Up</a></div>
                                                                                <div className="slide2_bottomtxt">From the Team Behind My Military Savings &amp; My Military Lifestyle</div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-xl-5 col-lg-5 col-md-12 col-12">
                                                                            <div className="slide2_img"><img src="assets/img/banner/slide2_img.png" border={0} alt="CircleOne Membership" /></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <button className="carousel-control-prev" type="button" data-bs-target="#carouselhomebanner" data-bs-slide="prev">
                                                            <span className="carousel-control-prev-icon" aria-hidden="true"><i className="fa-solid fa-chevron-left" /></span>
                                                            <span className="visually-hidden">Previous</span>
                                                        </button>
                                                        <button className="carousel-control-next" type="button" data-bs-target="#carouselhomebanner" data-bs-slide="next">
                                                            <span className="carousel-control-next-icon" aria-hidden="true"><i className="fa-solid fa-chevron-right" /></span>
                                                            <span className="visually-hidden">Next</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="tp-shop-area pt-50 pb-50" id="brands">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="tp-shop-main-wrapper">
                                    {/* <div className="tp-shop-top mb-45">
                                        <div className="row">
                                            <div className="col-xl-8">
                                                <h3 className="tp-section-title">Brands</h3>
                                            </div>

                                            <div className="col-xl-4">
                                                <div className="tp-header-search-2" style={{ position: 'relative' }}>
                                                    <form
                                                        onSubmit={(e) => {
                                                            e.preventDefault();
                                                            setConfirmedSearch(searchTerm.trim());
                                                            setCurrentPage(1);
                                                            setShowSuggestions(false);
                                                        }}
                                                    >
                                                        <input
                                                            type="text"
                                                            className="search_frmcntrl"
                                                            placeholder="Search for Brands..."
                                                            value={searchTerm}
                                                            onFocus={() => {
                                                                if (suggestions.length > 0) setShowSuggestions(true);
                                                            }}
                                                            onBlur={() => {
                                                                setTimeout(() => setShowSuggestions(false), 150); // delay to allow click
                                                            }}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setSearchTerm(value);

                                                                if (value.trim() === '') {
                                                                    setConfirmedSearch('');
                                                                    setCurrentPage(1);
                                                                    setSuggestions([]);
                                                                    setShowSuggestions(false);
                                                                } else {
                                                                    fetchSuggestions(value);
                                                                }
                                                            }}
                                                        />
                                                        <button type="submit">
                                                            <i className="fa-solid fa-magnifying-glass" />
                                                        </button>
                                                    </form>
                                                    <div
                                                        className="search_suggestion scrollbar_style"
                                                        style={{
                                                            display: showSuggestions && suggestions.length > 0 ? 'block' : 'none',
                                                            position: 'absolute',
                                                            top: '100%',
                                                            left: 0,
                                                            right: 0,
                                                            background: '#fff',
                                                            border: '1px solid #ccc',
                                                            zIndex: 1000,
                                                            maxHeight: '200px',
                                                            overflowY: 'auto'
                                                        }}
                                                    >
                                                        <ul>
                                                            {suggestions.map((item, index) => (
                                                                <li key={index}>
                                                                    <div
                                                                        onMouseDown={(e) => {
                                                                            e.preventDefault();
                                                                            setSearchTerm(item);
                                                                            setConfirmedSearch(item);
                                                                            setShowSuggestions(false);
                                                                            setCurrentPage(1);
                                                                        }}
                                                                    >
                                                                        {item}
                                                                    </div>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="tp-shop-items-wrapper tp-shop-item-primary home_topbrands">
                                        <div className="row mt-20 mb-35">
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                <h4 className="f_white text-center mt-15 mb-35">Featured Brands</h4>
                                            </div>
                                        </div>

                                        <div
                                            className="row tp_home_brands justify-content-center"
                                            style={{ minHeight: "250px" }}
                                        >
                                            {brands.length === 0 || loading ? (
                                                Array(5).fill(0).map((_, i) => (
                                                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4" key={i}>
                                                        <Skeleton height={200} />
                                                    </div>
                                                ))
                                            ) : (
                                                brands.map((brand) => (
                                                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4" key={brand._id}>
                                                        <div className="tp-product-item mb-40">
                                                            <Link to={`/product/${brand._id}`} state={{ filterLabel: "Brands" }}>
                                                                <div className="tp-product-thumb p-relative z-index-1 tp_homeadvertisers">
                                                                    <img
                                                                        src={brand.brandLogo || "/assets/img/brands/no_brand.png"}
                                                                        alt={brand.name}
                                                                    // loading="lazy"
                                                                    />
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    </div>

                                                ))
                                            )}
                                            <div className="w-100 d-flex justify-content-center">
                                                <Link to='/brands' className="tp-btn-blue1 tp_lrgebtn_pdng2 f_sz16 crsr_pntr">See All Brands </Link>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                </section>

                <ShoppingDeals />

                {/* <div className='tp-shop-pagination d-inline-flex w-100 justify-content-center'>
                    <Link to='/brands' className="tp-btn tp-btn-white tp-btn-themered"> show more </Link>
                </div> */}
                {/* <section className="tp-banner-area pt-30 pb-60">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12 col-lg-12">
                                <div className="tp-banner-item tp-banner-height p-relative mb-30 z-index-1 fix">
                                    <div className="tp-banner-thumb transition-3 bg_orange" />
                                    <div className="row">
                                        <div className="col-12 col-xl-6 col-md-6">
                                            <div className="tp-banner-content">
                                                <h2 className="tp-banner-title">
                                                    Get up to 12% cash back on eligible purchases, counseling, and other bespoke benefits for you and your family.
                                                </h2>
                                                <div className="tp-banner-btn pb-40">
                                                   
                                                    <button className="tp-btn tp-btn-white tp-btn-primary" disabled>
                                                        Coming Soon
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-xl-6 col-md-6 d-inline-flex align-items-center justify-content-center">
                                            <div className="membership_banner">
                                                <img
                                                    src="/assets/img/banner/membership.png"
                                                    alt="Membership benefits"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}
            </main>
            <Footer />


        </div>
    );
};

export default Home;